import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from "axios";
import Cookies from "js-cookie";

export const API_SERVER = function () {
    return process.env.REACT_APP_API_SERVER || "http://localhost:14019/api/";
}

export const NEW_API_SERVER = function () {
    return process.env.REACT_APP_NEW_API_SERVER || "http://localhost:3301/api/v1/";
}

export const isAuthenticated = () => {
    return !!Cookies.get("Authorization");
};


// const AuthGuard = ({children}) => {
//     // const account = useSelector((state) => state.account);
//     // axios
//     //     .post(NEW_API_SERVER() + "users/checkSession", account.user,
//     //         { headers: { Authorization: `${account.token}` } }).then(function (acc) {
//     //             if (acc.data.success === false) {
//     //                 // localStorage.clear();
//     //                 localStorage['isLoggedIn'] = false;
//     //             }
//     //         }, function (err) {
//     //             // localStorage.clear();
//     //             localStorage['isLoggedIn'] = false;
//     //         });

//     // debugger
//     // let { isLoggedIn } = account;
//     // const isLoggedIn = acc.data.success;

//     // Mahmood Heidari commented this out because we do not have authentication for now
//     // if (!isLoggedIn) {
//     //     return <Navigate to="/auth/signin" />;
//     // }

//     // localStorage['isLoggedIn'] = true;

//     // return children;

//     if (!isAuthenticated()) {
//         return <Navigate to="/login" replace />;
//     }
//     return <Outlet />;
//  return children;

// };
const AuthGuard = ({ children }) => {
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }
    return children;
};
export default AuthGuard;
